import {useState} from 'external/react'
import {styled, clsx} from 'external/material'
import {MessageIcon} from 'resources/icons'
import Message from 'components/Message'
import { centerVertically } from 'utils/style'

const StyledDashboardActivityMessage = styled('div')(dashboardActivityMessageStyles)

export default function DashboardActivityMessage(props) {

    const [[openMessage, anchorEl], setOpenMessage] = useState([false, null])
    const {message} = props

    return(<StyledDashboardActivityMessage className={props.className}>
        <div onClick={e => message && setOpenMessage([true, e.target])} className={clsx('message-button', {['no-message']: !!message})}>
            <div className="icon-container">
                <MessageIcon fill="#2c75bd" width={18} />
            </div>
        </div>
        <Message open={openMessage} anchorEl={anchorEl} {...message} onClose={() => setOpenMessage([false, null])} />
    </StyledDashboardActivityMessage>
   )
}

function dashboardActivityMessageStyles(){
    return {
        ...centerVertically,
        padding: 0,
        '& .message-button': {
            ...centerVertically,
            cursor: 'pointer',
            justifyContent: 'center',
            backgroundColor: '#edeff4',
            borderRadius: 100,
            width: 40,
            height: 40,
            '& .icon-container': {
                display: 'flex',
                justifyContent: 'center'
            }
        }
    }
}
